<template>
    <div class="login-wrapper">
        <div class="login-card">
            <div class="login-header">
                <div class="logo-container">
                    <img src="../assets/logo.png" alt="Logo" class="login-logo">
                </div>
                <h1>ເຂົ້າສູ່ລະບົບ</h1>
                <p>ລະບົບຈັດການໂຮງຮຽນ</p>
            </div>

            <form @submit.prevent="handleLogin" class="login-form">
                <div class="form-group">
                    <label for="username">ຊື່ຜູ້ໃຊ້</label>
                    <div class="input-container">
                        <i class="fas fa-user"></i>
                        <input 
                            type="text" 
                            id="username" 
                            v-model="loginData.username" 
                            placeholder="ກະລຸນາປ້ອນຊື່ຜູ້ໃຊ້" 
                            required
                        >
                    </div>
                </div>

                <div class="form-group">
                    <label for="password">ລະຫັດຜ່ານ</label>
                    <div class="input-container">
                        <i class="fas fa-lock"></i>
                        <input 
                            type="password" 
                            id="password" 
                            v-model="loginData.password" 
                            placeholder="ກະລຸນາປ້ອນລະຫັດຜ່ານ" 
                            required
                        >
                    </div>
                </div>

                <div class="form-options">
                    <label class="remember-me">
                        <input type="checkbox" v-model="rememberMe"> ຈື່ຂ້ອຍໄວ້
                    </label>
                    <a href="#" class="forgot-password">ລືມລະຫັດຜ່ານ?</a>
                </div>

                <button type="submit" :disabled="loading" class="login-button">
                    <span v-if="loading">ກຳລັງກວດສອບ...</span>
                    <span v-else>ເຂົ້າສູ່ລະບົບ</span>
                </button>

                <p v-if="errorMessage" class="error-msg">{{ errorMessage }}</p>
            </form>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';
import { auth } from '@/utils/auth';
export default {
    name: 'LoginPage',
    data() {
        return {
            loginData: {
                username: '',
                password: ''
            },
            rememberMe: false,
            loading: false,
            errorMessage: ''
        }
    },
    mounted() {
        // ກວດສອບເບິ່ງວ່າມີຊື່ຜູ້ໃຊ້ທີ່ເຄີຍຈື່ໄວ້ໃນ localStorage ຫຼືບໍ່
        const savedUsername = localStorage.getItem('remembered_username');
        if (savedUsername) {
            this.loginData.username = savedUsername;
            this.rememberMe = true;
        }
    },
    methods: {
        async handleLogin() {
            this.loading = true;
            this.errorMessage = '';
            
            try {
                const response = await api.post('/login', this.loginData, {
                    headers: {
                        'Authorization': 'Basic ' + btoa('admin:supersecret@laosoft')
                    }
                });

                const result = response.data;

                if (result.code === 1) {
                    const userInfo = result.rows;
                    auth.setAuth(userInfo.token, userInfo);

                    // ເລີ່ມຕົ້ນບັນທຶກເວລາເຄື່ອນໄຫວລ້າສຸດ
                    localStorage.setItem('lastActivity', Date.now().toString());

                    // ຖ້າຕິກ Remember Me ໃຫ້ເກັບ Username ໄວ້, ຖ້າບໍ່ໃຫ້ລຶບອອກ
                    if (this.rememberMe) {
                        localStorage.setItem('remembered_username', this.loginData.username);
                    } else {
                        localStorage.removeItem('remembered_username');
                    }
                    
                    // Redirect to home or to the page they came from
                    const redirect = this.$route.query.redirect || '/home/dashboard';
                    this.$router.push(redirect);
                } else {
                    this.errorMessage = result.desc || 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ';
                }
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data) {
                    this.errorMessage = error.response.data.desc || 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ';
                } else if (error.request) {
                    this.errorMessage = 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້ (Network Error)';
                } else {
                    this.errorMessage = 'ເກີດຂໍ້ຜິດພາດໃນການເຂົ້າສູ່ລະບົບ';
                }
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.login-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    font-family: 'Phetsarath OT', sans-serif;
}

.login-card {
    background: rgba(255, 255, 255, 0.95);
    padding: 2.5rem;
    border-radius: 20px;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
    text-align: center;
    transition: transform 0.3s ease;
}

.login-header h1 {
    color: #1e3c72;
    font-size: 1.8rem;
    margin: 1rem 0 0.5rem;
}

.login-header p {
    color: #666;
    margin-bottom: 2rem;
}

.login-logo {
    width: 80px;
    height: auto;
}

.form-group {
    text-align: left;
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: #333;
    font-weight: 500;
}

.input-container input {
    width: 100%;
    padding: 0.8rem 1rem;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 1rem;
    transition: border-color 0.3s;
    box-sizing: border-box;
}

.input-container input:focus {
    outline: none;
    border-color: #2a5298;
}

.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
}

.forgot-password {
    color: #2a5298;
    text-decoration: none;
}

.login-button {
    width: 100%;
    padding: 1rem;
    background: #2a5298;
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.3s;
}

.login-button:hover {
    background: #1e3c72;
}

.login-button:disabled {
    background: #ccc;
}

.error-msg {
    color: #d9534f;
    margin-top: 1rem;
    font-size: 0.9rem;
}
</style>